import axios from 'axios';

import { notifications } from '@mantine/notifications';

import { usePutApiDocumentsId } from '../../api/documents/documents.ts';
import { DocumentDto, DocumentUploadDto, ProjectDto } from '../../api/models';
import DocumentModal from './DocumentModal.tsx';

interface DocumentEditModalProps {
    opened: boolean;
    close: () => void;
    refetch: () => void;
    project: ProjectDto;
    document: DocumentDto;
}

const DocumentEditModal = ({
    opened,
    close,
    refetch,
    project,
    document
}: DocumentEditModalProps) => {
    const {
        mutateAsync: updateDocument,
        error,
        isPending
    } = usePutApiDocumentsId(); // ← your update mutation

    const handleUpdate = async (data: DocumentUploadDto) => {
        try {
            await updateDocument({ id: document.id, data });

            notifications.show({
                title: 'Document Updated',
                message: `${data.name} updated! ✔️`,
                loading: false,
                withCloseButton: true,
                autoClose: 2000
            });
        } catch (err) {
            const errorMessage =
                axios.isAxiosError(err) && err.response
                    ? `Server error: ${err.response.status} ${err.response.statusText}`
                    : 'An unexpected error occurred ❌';

            notifications.show({
                title: 'Document Update Failed',
                message: errorMessage,
                loading: false,
                withCloseButton: true,
                autoClose: 5000,
                color: 'red'
            });
        }
    };

    return (
        <DocumentModal
            opened={opened}
            onClose={close}
            onSubmit={handleUpdate}
            error={error}
            isPending={isPending}
            refetch={refetch}
            project={project}
            document={document}
            title='Edit Document'
            includeFileImport={false}
        />
    );
};

export default DocumentEditModal;
